import { render, staticRenderFns } from "./app-navigation.vue?vue&type=template&id=4e1394b6&scoped=true&"
import script from "./app-navigation.vue?vue&type=script&lang=js&"
export * from "./app-navigation.vue?vue&type=script&lang=js&"
import style0 from "./app-navigation.vue?vue&type=style&index=0&id=4e1394b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1394b6",
  null
  
)

export default component.exports